// React
import React from "react";
import PropTypes from "prop-types";
// Framework
import { makeStyles, Fade, Popover as MuiPopover } from "@material-ui/core";
import { classnames } from "ui/classnames";

////////////////////////////////////////////////////
/// Styles
////////////////////////////////////////////////////

const useStyles = makeStyles((theme) => ({
  root: ({ offset }) => ({
    margin: theme.spacing(
      offset.top || 0,
      offset.right || 0,
      offset.bottom || 0,
      offset.left || 0
    ),
  }),
  disablePointerEvents: {
    pointerEvents: "none",
  },
}));

////////////////////////////////////////////////////
/// Component
////////////////////////////////////////////////////

const Popover = ({
  open,
  anchorEl,
  disablePointerEvents,
  anchorOrigin = {
    vertical: "bottom",
    horizontal: "right",
  },
  transformOrigin = {
    vertical: "top",
    horizontal: "right",
  },
  offset = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
  },
  onClose,
  children,
  ...rest
}) => {
  // Styles
  const classes = useStyles({ offset });
  // Render
  return (
    <MuiPopover
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      TransitionComponent={Fade}
      className={classnames(classes.root, {
        [classes.disablePointerEvents]: disablePointerEvents,
      })}
      classes={{ paper: classes.paper }}
      {...rest}
    >
      {children}
    </MuiPopover>
  );
};

Popover.propTypes = {
  open: PropTypes.bool,
  anchorEl: PropTypes.object,
  disablePointerEvents: PropTypes.bool,
  onClose: PropTypes.func,
};

export default Popover;
